import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { useBlogTopics } from "../hooks/useBlogTopics";
import { useMonthlyEvents } from "../hooks/useMonthlyEvents";
import { useNewsLinks } from "../hooks/useNewsLinks";
import { usePressReleases } from "../hooks/usePressReleases";
import { useCategories } from "../hooks/useCategories";
import { useSiteMetadata } from "../hooks/useSiteMetadata";

import { setMonthlyEvents } from "../redux/slices/monthlyEventsSlice";
import { setBlogTopics, setPressReleases } from "../redux/slices/articleSlice";
import { setLinks } from "../redux/slices/inTheNewsSlice";
import { setFaqCategories } from "../redux/slices/categoriesSlice";
import { setEndpoints } from "../redux/slices/endpoints.slice";

const StaticQueriesWrapper = ({ children }) => {
    const blogTopics = useBlogTopics();
    const monthlyEvents = useMonthlyEvents();
    const inTheNewsLinks = useNewsLinks();
    const pressReleases = usePressReleases();
    const faqCategories = useCategories("FAQ");
    const { endpoints } = useSiteMetadata();

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setMonthlyEvents(monthlyEvents));
        dispatch(setBlogTopics(blogTopics));
        dispatch(setLinks(inTheNewsLinks));
        dispatch(setPressReleases(pressReleases));
        dispatch(setFaqCategories(faqCategories));
        dispatch(setEndpoints(endpoints));
    }, [
        dispatch,
        blogTopics,
        monthlyEvents,
        inTheNewsLinks,
        pressReleases,
        faqCategories,
        endpoints,
    ]);

    return children;
};

export default StaticQueriesWrapper;
